import { useEffect } from "react";
import { useToken } from "@bn/api";
import { readStoredToken, revokeWealthApiTokens } from "@helpers";

/** Dispatched on `window` by the ARIVA header when the user logs out there. */
export const ARIVA_LOGOUT_EVENT = "ariva:logout";

/**
 * Ends the app's session when the user logs out through the ARIVA header.
 * Tokens are deleted synchronously, because the header reloads the page right
 * after its logout; the revoke is best effort.
 */
export const useArivaLogout = (enabled: boolean) => {
  const { logout: tokenLogout } = useToken({ enabled: false });

  useEffect(() => {
    if (!enabled) return;

    const handleLogout = () => {
      const token = readStoredToken();
      tokenLogout();
      if (token) {
        void revokeWealthApiTokens(token);
      }
    };

    window.addEventListener(ARIVA_LOGOUT_EVENT, handleLogout);
    return () => window.removeEventListener(ARIVA_LOGOUT_EVENT, handleLogout);
  }, [enabled, tokenLogout]);
};
